module.exports = __webpack_public_path__ + "fonts/tragic-marker-regular.b11cae12.woff";